import classNames from 'classnames';
import { motion } from 'framer-motion';
import React, { FC } from 'react';
import styles from './Dots.module.css';

type TCarouselDots = {
    style?: { [key: string]: string }
    className?: string;
    activeIdx: number;
    MediaPool: any[];
    handleDotSelect: (i: number) => void;

}

export const CarouselDots: FC<TCarouselDots> = ({
    style,
    className = 'video-carousel-dots',
    activeIdx,
    MediaPool,
    handleDotSelect
}) => {
    return (
        <div style={{ ...style }} className={classNames(styles.dotsWrapper, className, 'carouselDotsWrapper')}>
            {
                MediaPool.length > 1 &&

                MediaPool.map((v, i) => {
                    const active = activeIdx === i;
                    return (
                        <motion.div
                            key={'carousel-dot-' + i}
                            onClick={() => handleDotSelect(i)}
                            animate={{ background: active ? '#84bd00' : 'rgb(209, 210, 208, 0.5)' }}
                            className={classNames('dot', styles.dot, { active: active })}>
                        </motion.div>
                    )
                }
                )
            }
        </div >
    )
}